import React from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { TOP_NAV_SOURCE } from '../../../constants';
import Link from '../Link';

export const SwitchToFiverrLink = (props) => {
    const path = pathfinder(
        'root',
        {},
        {
            query: {
                source: TOP_NAV_SOURCE,
            },
        }
    );

    return (
        <Link {...props} href={path} className="nav-link nav-link-green">
            {(i18n) => i18n.t('header.home')}
        </Link>
    );
};
